import TickerPrice from './TickerPrice'
export { TickerPrice }
export default TickerPrice
